<template>
  <div class="home">
    <!-- 省市县选择 -->
    <listselect v-if="listSelectShow==true" class="listselect" :map="map" style="top: 10px;"></listselect>
    <!-- 降雨等值面图时间选择 -->
    <jydzm v-if="btnactivelen==0" :map="map" :ydbgisData="ydbgisData"></jydzm>
    <bottomBar v-if="btnactivelen==0" @nowstatus="nowstatus" @picShow="picShow"></bottomBar>
    <leftPageYb class="homel" v-if="btnactivelen==0 && nowState=='预报'" @bzswitch="bzswitch" @bigDialogData="bigDialogData" @ClickNames="ClickNames1"></leftPageYb>
    <leftPageYJ class="homel" v-if="btnactivelen==0 && nowState=='预警'" @bzswitch="bzswitch" @bigDialogData="bigDialogData" @pdfShow="pdfShow" @ClickNames="ClickNames"></leftPageYJ>
    <rightPageYb class="homer" v-if="btnactivelen==0 && nowState=='预报'" :bzswitchClick="bzswitchClick" @bigDialogData="bigDialogData" @ClickNames="ClickNames1"></rightPageYb>
    <rightPageYJ class="homer" v-if="btnactivelen==0 && nowState=='预警'" :bzswitchClick="bzswitchClick" @bigDialogData="bigDialogData" @ClickNames="ClickNames"></rightPageYJ>
    <!-- 大图展示弹窗 -->
    <bigDialog v-if="bigDialogVisible==true" @cancel="bigCancel" :bigData="bigData"></bigDialog>
    <!-- 饼柱图击穿弹窗 -->
    <jcDialog v-if="jcDialogVisible==true" @cancel="jcCancel" @queryDatas="querydata" :jichuanData="jichuanData"></jcDialog>
    <!-- pdf浏览弹窗 -->
    <pdfDialog v-if="pdfDialogVisible==true" @cancel="pdfCancel" :pdfurl="pdfurl"></pdfDialog>
  </div>
</template>
<script>
import { loginSuper } from './req.js'
import { ydbjbxxsearch, selectYdbjichuanList } from '@/api/api.js'

import bottomBar from './bottomBar.vue';
import jydzm from '@/components/visualization/jydzmpc.vue';
import leftPageYb from './leftPageYb.vue';
import leftPageYJ from './leftPageYJ.vue';
import rightPageYb from './rightPageYb.vue';
import rightPageYJ from './rightPageYJ.vue';
import bigDialog from './bigDialog.vue';
import jcDialog from './jcDialog.vue';
import pdfDialog from '@/components/visualization/pdfDialog.vue';
import listselect from '@/components/visualization/LlistSelectJYpc.vue';
export default {
  props: ['gisClick', 'map', 'querydatas', 'dbRouteShow', 'ydbgisData'],
  data() {
    return {
      btnactivelen: 0,
      gisrightdata: null,
      //大图点击事件数据
      listSelectShow: true,
      bigData: null,
      bigDialogVisible: false,
      bzswitchClick: null,
      picDialogVisible: false,
      jcDialogVisible: false,
      pdfDialogVisible: false,
      pdfurl: null,
      nowState: null, //当前四预状态
      jichuanData: null,
    }
  },
  components: {
    bottomBar,
    leftPageYb,
    leftPageYJ,
    rightPageYb,
    rightPageYJ,
    bigDialog,
    jcDialog,
    jydzm,
    pdfDialog,
    listselectloginSuper
  },
  mounted() {
    // if (localStorage.getItem("toKen") == null){
      loginSuper(() => {
        location.reload()
      })
    // }
    this.$emit("activeRoute", 1);
    if (this.dbRouteShow == true) {
      this.btnactivelen = 3;
    } else {
      this.btnactivelen = 0;
    }
  },
  methods: {
    //饼柱切换事件
    bzswitch(data) {
      this.bzswitchClick = data;
    },

    //大图点击事件数据
    bigDialogData(data) {
      this.bigData = data;
      this.bigDialogVisible = true;
    },

    // 发送信息提示弹窗
    picShow(data) {
      this.picDialogVisible = true;
    },

    //饼柱图击穿事件
    ClickNames(data) {
      this.jcDialogVisible = true;
      this.jichuanData = data;

      let bxlj, sfyr, JYDJ, bx, zyss, ly;
      if (data[0].bxlj) {
        bxlj = data[0].bxlj;
      }
      if (data[0].sfyr) {
        sfyr = data[0].sfyr;
      }
      if (data[0].JYDJ) {
        JYDJ = data[0].JYDJ;
      }
      if (data[0].bx) {
        bx = data[0].bx;
      }
      if (data[0].zyss) {
        zyss = data[0].zyss;
      }
      if (data[0].ly) {
        ly = data[0].ly;
      }
      let params = {
        regionCode: data[0].regionCode,
        yuShi: this.$store.state.yuShi,
        bxlj: bxlj,
        sfyr: sfyr,
        JYDJ: JYDJ,
        bx: bx,
        zyss: zyss,
        ly: ly,
      };
      selectYdbjichuanList(params).then((res) => {
        this.$store.state.jcgisData = res.data;
      });
    },
    ClickNames1(data) {
      this.jcDialogVisible = true;
      this.jichuanData = data;
    },

    //pdf弹窗打开并传参数
    pdfShow() {
      this.pdfurl = '/geodata/预警等级.pdf';
      this.pdfDialogVisible = true;
    },
    showpdfya() {
      this.pdfurl = '/geodata/XX坝防汛预案.pdf';
      this.pdfDialogVisible = true;
    },

    querydata(data) {
      this.$emit("dbData", data);
    },
    btnClick(item, i) {
      this.btnactivelen = i;
    },
    clickData(item) {
      // this.map.flyTo([Number(item.ydbWeiDu), Number(item.ydbJingDu)], 15);
      this.$store.commit('fanhuiFun', false); //token
      let params = {
        ydbCode: item.ydbCode
      };
      let _this = this;
      ydbjbxxsearch(params).then((res) => {
        _this.gisrightdata = res.data;
        _this.$store.commit('ydbYjResultsFun', res.data); //token
      });
    },
    bigCancel() {
      this.bigDialogVisible = false;
    },
    picCancel() {
      this.picDialogVisible = false;
    },
    jcCancel() {
      this.jcDialogVisible = false;
    },
    pdfCancel() {
      this.pdfDialogVisible = false;
    },

    nowstatus(data) {
      this.nowState = data;
      this.bzswitchClick = null;
    },
  },
  computed: {
    fanhuiStatus() {
      return this.$store.state.fanhuiShow; //需要监听的数据
    },
  },
  watch: {
    gisClick: {
      handler(newVal, oldVal) {
        let _this = this;
        if (newVal) {
          this.btnactivelen = 3;
          this.$emit("rootBarShow", true);
          setTimeout(function () {
            _this.gisrightdata = newVal;
          }, 200);
        }
      },
      immediate: true,
      deep: true,
    },
    querydatas(data, data1) {
      // console.log(this.$store.state.querydatas,'storeindex数据')
      if (!data) {
        data = this.$store.state.querydatas
      }
      // console.log(data,this.$store.state.querydatas,'获取单坝---汛情检测')
      let _this = this;
      if (!data) {
        this.btnactivelen = 0;
        this.$emit("rootBarShow", false);
        this.$store.commit('fanhuiFun', true); //token
      } else {
        this.btnactivelen = 3;
        this.$emit("rootBarShow", true);
        this.$store.commit('fanhuiFun', false); //token
        setTimeout(function () {
          _this.gisrightdata = data;
        }, 200);
      }
    },
    fanhuiStatus(newVal, oldVal) {
      // console.log('---->返回--',newVal)
      if (newVal == true) {
        this.btnactivelen = 0;
        this.gisrightdata = null;
        this.$emit("rootBarShow", false);
      }
    }
  }
}
</script>

<style scoped="scoped">
.home {
  position: absolute;
  left: 0;
  height: 0;
  width: 100%;
  height: 100%;
  /* z-index: 1; */
}

.homel,
.homer {
  width: 380px;
  position: absolute;
  z-index: 100;
  overflow: auto;
  top: 0;
  bottom: 0;
}

.homel {
  left: 10px;
}

.homer {
  right: 10px;
}

.shipinButton {
  position: absolute;
  right: 400px;
  top: 190px;
  width: 50px;
  height: 50px;
  z-index: 10;
  color: #fff;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  background: url(../../common/images/video.png) no-repeat center;
  background-size: 100% 100%;
}

.jyselect {
  float: right;
  width: 220px;
  z-index: 100;
  margin-right: 400px;
  margin-top: 10px;
}
/* >>>.el-select {
    width: 120px !important;
  } */

>>> .el-input--suffix .el-input__inner {
  color: #fff !important;
  background: transparent;
  //border: 1px solid #00b3fe;
  //background-color: rgba(9, 34, 72, 0.5);
}

>>> .el-select-dropdown {
  background: transparent !important;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5) !important;
}
</style>
